// src/services/audit.service.ts
import { http } from '../api/http';
import type { AuditEventsResponse } from '../types/Audit';

export type AuditOrder = 'desc' | 'asc';

export interface GetAuditEventsParams {
  q?: string;
  event_type?: string;
  actor_user_id?: string;
  subject_user_id?: string;
  user_name?: string;

  origin?: string;
  result?: string;

  from?: string; // YYYY-MM-DD
  to?: string;   // YYYY-MM-DD

  order?: AuditOrder;
  page?: number;
  pageSize?: number;
}

function buildQuery(params: GetAuditEventsParams) {
  const sp = new URLSearchParams();

  const setIf = (k: string, v: any) => {
    if (v === undefined || v === null) return;
    const s = String(v).trim();
    if (!s) return;
    sp.set(k, s);
  };

  setIf('q', params.q);
  setIf('event_type', params.event_type);
  setIf('actor_user_id', params.actor_user_id);
  setIf('subject_user_id', params.subject_user_id);
  setIf('user_name', params.user_name);
  setIf('origin', params.origin);
  setIf('result', params.result);
  setIf('from', params.from);
  setIf('to', params.to);

  setIf('order', params.order || 'desc');
  setIf('page', params.page ?? 1);
  setIf('pageSize', params.pageSize ?? 20);

  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

export const AuditService = {
  /**
   * GET /audit/events
   * Espera: { data: AuditEvent[], meta: { page, pageSize, total, totalPages } }
   */
  getEvents(params: GetAuditEventsParams = {}) {
    return http<AuditEventsResponse>(`/audit/events${buildQuery(params)}`);
  }
};
